export default __webpack_public_path__ + "static/media/242.5abbc470.gif";